// extracted by mini-css-extract-plugin
export default {"title":"PaymentToWholesalerDetails_title__HI17z","total":"PaymentToWholesalerDetails_total__9I-SF","edit":"PaymentToWholesalerDetails_edit__4H+tP"};